export default __webpack_public_path__ + "static/media/19.a40bbf60.jpg";